//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from "vuex";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQUploader from "@/components/Generics/AQUploader/AQUploader.vue";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import AQEmptySearch from "@/components/Generics/AQEmptySearch/AQEmptySearch.vue";
import AQDropdown from "@/components/Generics/AQDropdown/AQDropdown.vue";
import AQToggle from "@/components/Generics/AQToggle/AQToggle.vue";
import AQCheckbox from "@/components/Generics/AQCheckbox/AQCheckbox.vue";

import { uuid } from "short-uuid";

import QFabricModal from "../../q-fabric-modal.vue";

export default {
    name: "QfMAssistantAction",
    components: { QFabricModal, AQInput, AQDropdown, AQToggle, AQCheckbox, AQCard, AQEmptySearch, AQUploader },
    props: {
        isInEdit: { type: Boolean, default: false },
        currentAssistantItem: { type: Object, default: () => ({}) },
        docsList: { type: Array, default: () => [] },
        assistantListActions: { type: Array, default: () => [] }
    },
    data() {
        return {
            thumbStyle: {
                right: "-7px", borderRadius: "2px", width: "4px", opacity: 0.4
            },
            assistantData: {},
            localShow: true,
            typeOptions: [
                { label: this.$t("userInterface.auraAssist.summarizeAct"), value: "summarize" },
                { label: this.$t("userInterface.auraAssist.targetedSum"), value: "targeted" },
                { label: this.$t("userInterface.auraAssist.conversationAct"), value: "conversation" },
                { label: this.$t("userInterface.auraAssist.custom"), value: "custom" }
            ],
            firstLoad: true,
            searchDocs: "",
            checkAll: false,
            nameValidation: false,
            duplicatedName: false,
            typeValidation: false,
            instructionsValidation: false,
            additionalDocsLocal: [],
            loadingState: false,
            initialVals: null
        };
    },
    computed: {
        ...mapGetters("apps", ["currentApp"]),
        actions() {
            return [{ label: this.$t("generic.done"), name: "done" }];
        },
        title() {
            return this.isInEdit ? this.$t("userInterface.auraAssist.editTitle") : this.$t("userInterface.auraAssist.title");
        },
        filteredList() {
            const lowerCaseValue = this.searchDocs.toLowerCase();
            return this.docsList.filter(doc => (doc.label || "").toLowerCase().includes(lowerCaseValue));
        },
        getInfoTextMsg() {
            return this.assistantData.action === "targeted" ? this.$t("userInterface.auraAssist.targetedSumInfoBox")
                : this.$t("userInterface.auraAssist.conversationInfoBox");
        },
        nameErrorMsg() {
            return this.nameValidation ? this.$t("errorRequired") : this.$t("globalDataModel.duplicateName");
        }
    },
    created() {
        this.assistantData = { ...this.currentAssistantItem };
        this.initialVals = JSON.stringify(this.currentAssistantItem);
        this.additionalDocsLocal = this.assistantData.additionalDocs ? [...this.assistantData.additionalDocs] : [];
    },
    methods: {
        ...mapActions("components", ["docUploadAI"]),
        modalAction(act) {
            if (act.simple === "hide") {
                this.localShow = false;
            } else if (act.simple === "action") {
                if (act.detailed === "done") {
                    const { instructions, name, id, action, userPrompt, userRepliesPrompt,
                        selectedDocs, allowUserSelDocs } = this.assistantData;
                    if (!name) {
                        this.nameValidation = true;
                    }
                    if (!action) {
                        this.typeValidation = true;
                    }
                    this.instructionsValidation = (!instructions && action !== "custom" && action !== "conversation") || (!instructions && !userPrompt);
                    if (this.nameValidation || this.typeValidation || this.duplicatedName || this.instructionsValidation) {
                        return;
                    }
                    this.localShow = false;
                    const dataToEmit = {
                        name,
                        action,
                        id: id || uuid(),
                        selectedDocs,
                        additionalDocs: this.additionalDocsLocal,
                        allowUserSelDocs,
                        instructions,
                        userPrompt,
                        userRepliesPrompt
                    };
                    this.$emit("actionsList", dataToEmit);
                    if (this.initialVals !== JSON.stringify(dataToEmit)) {
                        this.$root.$emit("showCheckedSaveBtn", false);
                        this.$store.commit("main/setInterfaceDirty", true);
                    }
                } else if (act.detailed === "close") {
                    this.localShow = false;
                }
            }
        },
        selectAction(data) {
            if (this.firstLoad) {
                setTimeout(() => {
                    this.firstLoad = false;
                }, 100);
                return;
            }
            this.checkAll = false;
            this.typeValidation = false;
            this.assistantData.selectedDocs = [];
            this.instructionsValidation = false;
            this.assistantData.userPrompt = false;
            this.assistantData.allowUserSelDocs = true;
            this.assistantData.userRepliesPrompt = false;
            this.assistantData.action = data;
            switch (this.assistantData.action) {
                case "summarize":
                    this.assistantData.instructions = this.$t("userInterface.auraAssist.summaryDefaultBody");
                    break;
                case "targeted":
                    this.assistantData.instructions = this.$t("userInterface.auraAssist.targetedSumBody");
                    break;
                case "conversation":
                    this.assistantData.instructions = this.$t("userInterface.auraAssist.convDefaultBody");
                    this.assistantData.userPrompt = true;
                    this.assistantData.userRepliesPrompt = true;
                    break;
                default:
                    this.assistantData.instructions = "";
                    break;
            }
        },
        uploadDoc(file) {
            if (file && file.length) {
                let docUpload = file[0];
                const formDataUpdate = new FormData();
                formDataUpdate.append("file", docUpload);
                formDataUpdate.append("applicationId", this.currentApp.id);
                this.loadingState = true;
                this.docUploadAI(formDataUpdate).then(data => {
                    if (data) {
                        this.additionalDocsLocal.push({
                            docName: data.data.filename,
                            docId: data.data.fileUUID
                        });
                        this.$refs.uploader.removeFile();
                        this.loadingState = false;
                        docUpload = null;
                    }
                });
            }
        },
        deleteUploadedDoc(idx) {
            this.additionalDocsLocal.splice(idx, 1);
        },
        modalAfterHide() {
            this.$emit("input", false);
        },
        selectAllDocs(val) {
            this.assistantData.selectedDocs = val ? this.filteredList.map(el => el.code) : [];
        },
        resetErrorUserPrompt(val) {
            if (val) {
                this.instructionsValidation = false;
            }
        },
        adjustCheckAll() {
            this.checkAll = this.assistantData.selectedDocs.length === this.filteredList.length;
        },
        searchForDocs(searchValue) {
            this.searchDocs = searchValue;
        },
        resetToggleSelDocs() {
            this.searchDocs = "";
            this.checkAll = false;
            this.assistantData.selectedDocs = [];
        },
        inputName() {
            this.nameValidation = false;
            this.duplicatedName = false;
        },
        checkDuplicatedName() {
            this.duplicatedName = this.assistantListActions.some(el => el.name === this.assistantData.name && el.id !== this.assistantData.id);
        },
        resetToDefault() {
            this.instructionsValidation = false;
            switch (this.assistantData.action) {
                case "summarize":
                    this.assistantData.instructions = this.$t("userInterface.auraAssist.summaryDefaultBody");
                    break;
                case "targeted":
                    this.assistantData.instructions = this.$t("userInterface.auraAssist.targetedSumBody");
                    break;
                case "conversation":
                    this.assistantData.instructions = this.$t("userInterface.auraAssist.convDefaultBody");
                    break;
                default:
                    this.assistantData.instructions = "";
                    break;
            }
        }
    }
};
